import api from "../../../api/comptabilite/_comptable";

const state = () => ({
    liste_fournisseurs: [],
    liste_dette: [],
    liste_historique_paiement_dette: [],
    dette_est_paye: 0,
    dette_montant_restant: 0,

    recap_depense_budgetaire: [],
    liste_recap_depense_budgetaire_detaille: [],
    charge_apport_social: [],
});

// getters
const getters = {
    liste_fournisseurs: (state) => {
        return state.liste_fournisseurs;
    },

    liste_dettes: (state) => {
        return state.liste_dettes;
    },

    liste_historique_paiement_dette: (state) => {
        return state.liste_historique_paiement_dette;
    },

    dette_est_paye: (state) => {
        return state.dette_est_paye;
    },

    dette_montant_restant: (state) => {
        return state.dette_montant_restant;
    },

    recap_depense_budgetaire: (state) => {
        return state.recap_depense_budgetaire;
    },

    liste_recap_depense_budgetaire_detaille: (state) => {
        return state.liste_recap_depense_budgetaire_detaille;
    },

    charge_apport_social: (state) => {
        return state.charge_apport_social;
    },
};
// mutations
const mutations = {
    SET_LISTE_FOURNISSEURS(state, liste) {
        state.liste_fournisseurs = liste;
    },

    SET_LISTE_DETTES(state, liste) {
        state.liste_dettes = liste;
    },

    SET_LISTE_HISTORIQUE_PAIEMENT_DETTE(state, liste) {
        state.liste_historique_paiement_dette = liste;
    },

    SET_DETTE_EST_PAYE(state, liste) {
        state.dette_est_paye = liste;
    },

    SET_DETTE_MONTANT_RESTANT(state, liste) {
        state.dette_montant_restant = liste;
    },

    SET_RECAP_DEPENSE_BUDGETAIRE(state, recap) {
        state.recap_depense_budgetaire = recap;
    },

    SET_LISTE_RECAP_DEPENSE_BUDGETAIRE_DETAILLE(state, recap) {
        state.liste_recap_depense_budgetaire_detaille = recap;
    },

    SET_CHARGE_APPORT_SOCIAL(state, recap) {
        state.charge_apport_social = recap;
    },
};

// actions
const actions = {
    getContextePaiementPrestataire(context, data) {
        return new Promise((resolve, reject) => {
            api.getContextePaiementPrestataire(data, data.access_token).then(resolve, reject);
        });
    },

    payerDettePrestataire(context, data) {
        return new Promise((resolve, reject) => {
            api.payerDettePrestataire(data, data.access_token).then(resolve, reject);
        });
    },
    importerDettesPrestataires(context, data) {
        return new Promise((resolve, reject) => {
            api.importerDettesPrestataires(data, data.access_token).then(resolve, reject);
        });
    },

    importerDettesPrestatairesV2(context, data) {
        return new Promise((resolve, reject) => {
            api.importerDettesPrestatairesV2(data, data.access_token).then(resolve, reject);
        });
    },

    getDetailDettePrestataire(context, data) {
        return new Promise((resolve, reject) => {
            api.getDetailDettePrestataire(data).then(resolve, reject);
        });
    },

    appliquerCloturesPrestataires(context, data) {
        return new Promise((resolve, reject) => {
            api.appliquerCloturesPrestataires(data, data.access_token).then(resolve, reject);
        });
    },

    modifierBaseRemuneration(context, data) {
        return new Promise((resolve, reject) => {
            api.modifierBaseRemuneration(data, data.access_token).then(resolve, reject);
        });
    },

    getListeFournisseur({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeFournisseur().then(
                (response) => {
                    commit("SET_LISTE_FOURNISSEURS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeDette({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeDette(data).then(
                (response) => {
                    commit("SET_LISTE_DETTES", Array.isArray(response) ? response : (response && Array.isArray(response.dettes) ? response.dettes : []));
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveDette({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveDette(data).then(
                (response) => {
                    dispatch("getListeFournisseur");
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    removeDette({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.removeDette(data).then(
                (response) => {
                    dispatch("getListeFournisseur");
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveReglementDette({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveReglementDette(data).then(
                (response) => {
                    dispatch("getListeFournisseur");
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeHistoriqueDette({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeHistoriqueDette(data).then(
                (response) => {
                    commit("SET_LISTE_HISTORIQUE_PAIEMENT_DETTE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    checkIfDetteIsPaid({ commit }, dette_id) {
        return new Promise((resolve, reject) => {
            api.checkIfDetteIsPaid(dette_id).then(
                (response) => {
                    commit("SET_DETTE_EST_PAYE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDetteMontantRestant({ commit }, dette_id) {
        return new Promise((resolve, reject) => {
            api.getDetteMontantRestant(dette_id).then(
                (response) => {
                    commit("SET_DETTE_MONTANT_RESTANT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapDepenseBudgetaire({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapDepenseBudgetaire(data).then(
                (response) => {
                    commit("SET_RECAP_DEPENSE_BUDGETAIRE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRecapDepenseBudgetaireDetail({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeRecapDepenseBudgetaireDetail(data).then(
                (response) => {
                    commit("SET_LISTE_RECAP_DEPENSE_BUDGETAIRE_DETAILLE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeApportSocial({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeApportSocial(data).then(
                (response) => {
                    commit("SET_CHARGE_APPORT_SOCIAL", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
